import * as types from './types';

const fetchUserInfo = () => ({
  type: types.FETCH_USER_INFO,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/userInfo`,
    method: 'GET'
  }
});

const maskUser = () => ({
  type: types.MASK_USER
});

const notMaskUser = () => ({
  type: types.NOT_MASK_USER
});

const acceptTermsAndConditions = () => ({
  type: types.ACCEPT_TERMS_CONDITIONS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/userInfo/acceptTermsAndConditions',
    method: 'POST'
  }
});

const userFromApp = () => ({
  type: types.USER_FROM_APP
});

const showLogin = bool => ({
  type: types.SHOW_LOGIN,
  meta: {
    status: bool
  }
});

export { fetchUserInfo, maskUser, notMaskUser, acceptTermsAndConditions, userFromApp, showLogin };
